"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _RecommendationStepper = _interopRequireDefault(require("./RecommendationStepper"));
var _RecommendationBodyFactory = _interopRequireDefault(require("./RecommendationBodyFactory"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var RecommendationBody = function RecommendationBody(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    layout: {
      sm: [12]
    },
    justify: 'center'
  }, /*#__PURE__*/_react.default.createElement(_RecommendationStepper.default, null), /*#__PURE__*/_react.default.createElement(_RecommendationBodyFactory.default, props)));
};
var _default = RecommendationBody;
exports.default = _default;